<script>
import { VBTooltip } from 'bootstrap-vue';
const MAX_LENGTH = 42;

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    isParent: {
      type: Boolean,
      default: false,
    }
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      iconComponentsMap: {
        'pdf': 'IconTextFile',
        'jpg': 'IconImageFile',
        'jpeg': 'IconImageFile',
        'png': 'IconImageFile',
        'jpeg': 'IconImageFile',
        'mp3': 'IconSoundFile',
        'mp4': 'IconVideoFile',
        'webm': 'IconVideoFile',
        'ogg': 'IconVideoFile',
      }
    };
  },

  computed: {
    truncatedFileName () {
      const fileName = `${this.message.file.title}.${this.message.file.extension}`;

      if (fileName.length <= MAX_LENGTH) {
        return fileName;
      }

      return fileName.slice(0, MAX_LENGTH) + '...';
    },

    completeFileName () {
      return `${this.message.file.title}.${this.message.file.extension}`;
    },

    iconComponentName () {
      const componentName = this.iconComponentsMap[this.message.file.extension];

      if (!componentName) {
        return 'IconFile';
      }

      return componentName;
    },

    formattedText () {
      let messageText = this.message.text;

      if (!messageText) {
        return null;
      }

      messageText = messageText.replace(/((https?:\/\/)[^\s]+)/g, (url) => `<a href="${url}" target="_blank">${url}</a>`); // Hypertext link

      // Check for not being inside an <a ...>...</a>
      const notInsideAnchor = "(?![^<]*</a>)";

      messageText = messageText.replace(new RegExp("\\*([^*]+)\\*" + notInsideAnchor, "g"), '<b>$1</b>'); // Bold
      messageText = messageText.replace(new RegExp("_([^_]+)_" + notInsideAnchor, "g"), "<i>$1</i>"); // Italic
      messageText = messageText.replace(new RegExp("~([^~]+)~" + notInsideAnchor, "g"), "<s>$1</s>"); // Line through
      messageText = messageText.replace(new RegExp("```([^`]+)```" + notInsideAnchor, "g"), "<tt>$1</tt>"); // Monospaced

      return messageText;
    },
  },

  methods: {
    openFileModal () {
      Bus.$emit('openFileModal', this.message.file);
    }
  }
}
</script>

<template>
  <div>
    <button
      @click="openFileModal"
      class="attendence-message-file"
    >
      <Component :is="iconComponentName" />
      <span
        v-b-tooltip
        :title="completeFileName.length > 42 ? completeFileName : ''"
        class="text-nowrap"
      >
        {{ truncatedFileName }}
      </span>
    </button>
    <p
      v-if="message.has_legend && !isParent"
      class="message-legend mb-0"
    >
      {{ formattedText }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.attendence-message-file {
  width: fit-content;
  display: flex;
  align-self: center;
  justify-content: center;
  background-color: transparent;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid $salesflow-outline-gray-medium;
  border-radius: 14px;

  @include salesflow-text($font-weight: 600);

  &:hover {
    background-color: $salesflow-outline-gray-light;
  }
}

.message-legend {
  font-weight: 500;
  white-space: pre-wrap;
}

</style>
